import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from '../shared';
import {StatisticsModule} from '../shared/layout/statistics.module';
import {SharedModule as SharedNgModule} from 'primeng/api';
import {CategoryModule} from '../shared/layout/category.module';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {PasswordResetComponent} from './password-reset.component';
import {PasswordResetRoutingModule} from './password-reset-routing.module';
import {ToastModule} from 'primeng/toast';

@NgModule({
    imports: [
        SharedModule,
        PasswordResetRoutingModule,
        StatisticsModule,
        CategoryModule,
        SharedModule,
        SharedNgModule,
        InputTextModule,
        ButtonModule,
        ToastModule
    ],
    declarations: [
        PasswordResetComponent
    ]
})
export class PasswordResetModule {}
